// 不同环境的分类跳转链接：https://hellobike.yuque.com/gakadl/gqsekm/qhzdkbyn1406ccib
import { getAppEnv } from '../env/env';
import JumpMarket from './goMarketing';

type EnvType = 'fat' | 'uat' | 'pro';

interface CategoryLinkMap {
  [env: string]: {
    [categoryId: string]: string;
  };
}

export const categoryMapArr = {
  fat: ['3487', '3488'], // '101',
  uat: ['4416', '4417'],
  pro: ['3959', '3960'],
};

const categoryLinkMap: CategoryLinkMap = {
  fat: {
    3487: 'bike',
    3488: 'ebike',
  },
  uat: {
    4416: 'bike',
    4417: 'ebike',
  },
  pro: {
    3959: 'bike',
    3960: 'ebike',
  },
};

export function jumpToCategoryLink(env: EnvType, categoryId: string, spuId: string) {
  const cardType = categoryLinkMap[env]?.[categoryId];

  if (!cardType) {
    console.warn(`未找到匹配的cardType，env=${env}，categoryId=${categoryId}`);
    return;
  }

  // https://hellobike.yuque.com/lbqzgo/ieoyvf/ognigzc1xn27ooqh
  const url = `https://m.hellobike.com/AppPlatformH5/${getAppEnv() === 'pro' ? '' : `${getAppEnv()}/`}latest/index.html#/newClient?cardType=${cardType}&adsource=appkqsc&spuId=${spuId}`;
  JumpMarket.goPage(url, false, false);
}

// 退款跳转两轮页面：如果是两轮权益卡的单车骑行卡，需要跳转对应链接
// 单车
export const businessKeyBike = [
  'Hello0073', // fat
  'Hello0028', // uat
  'Hello0001', // pro
];
// 助力车
export const businessKeyEBike = [
  'Hello0066', // fat
  'Hello0025', // uat
  'Hello0002', // pro
];
